import { useMemo } from 'react';

import { useQuery } from '@apollo/client/react';

import { GET_LINKED_LISTING_IDS_FOR_TEAMS } from '@modules/transactions/transactionQueries';

export const useExcludedListingIds = (
  teamIds: string[] | undefined,
): { excludedIds: number[]; loading: boolean } => {
  const { data, loading } = useQuery(GET_LINKED_LISTING_IDS_FOR_TEAMS, {
    variables: { teamIds: teamIds ?? [] },
    skip: !teamIds?.length,
  });

  const excludedIds = useMemo(
    () => data?.property_transactions_listings.map(l => l.listing_id) ?? [],
    [data],
  );

  return { excludedIds, loading };
};
